/* eslint-disable */

import { getDistance } from "./helpers";
import { store } from "../stores/mainStore";
import { integration } from "../integration";

var lastTimeSecs = 0;
var numDiceStopped = 0;

export function update (time, delta)
{
	const m = window.manager;
	if(!m){
		console.warn('game running, should be stopping.')
		return;
	}

	// if(m.sceneRestarting === true) {
	// 	return;
	// }

	// if(m.diceStatus != 'launching')
	// // if(m.diceStatus == 'stopped' || m.diceStatus == 'arrivedInCup')
	// 	return;

	// if(m.showCupDebugInfo && m.cup && m.cup.cupSprite && store.activeMatch && store.activeMatch.matchId)
	// 	m.cup.updateCupDebugInfo();

	if(m.diceStatus === 'introToCup') {
		let movePixels = 16 * m.scaleFactor;
		for(let i = 0;i < 9;i++) {
			let d = m.diceHand.dice[i];
			let distance = getDistance(d.diceSprite.x, d.diceSprite.y, d.lastPosition.x, d.lastPosition.y);
			// let fastEnough = (Math.abs(d.diceSprite.body.velocity.x) > 2.5 && Math.abs(d.diceSprite.body.velocity.y) > 2.5);
			if(d.frameNum >= 0) {
				if(distance > movePixels) {
					d.lastPosition.x = d.diceSprite.x;
					d.lastPosition.y = d.diceSprite.y;
					if(++d.frameNum >= 9)
						d.frameNum = 0;
					// var str ='dice'+(i+1)+'_' + (d.frameNum+1);
					d.diceImage.setTexture('dice3D_sheet', (i*9)+d.frameNum);
					// console.log("X:"+d.diceSprite.x+" Y:"+d.diceSprite.y+" setting texture: "+str);
				}
			}
		}
		return;
	}

	if(m.diceStatus === 'launching') {
		if(m.diceHand.diceLaunched < 9) {
			var secs = time / 100;
			if((secs - lastTimeSecs) >= 0.15) {
				lastTimeSecs = secs;
	//            console.log("time:"+time/1000+" delta:"+delta);
				if(m.diceHand.diceLaunched === 0) {
					if(!m.diceReceived) {
						// m.text.text = "waiting for server dice";
						return;
					}
				}
				if(m.diceHand.diceLaunched === 0 || m.diceHand.diceLaunched === 2 || m.diceHand.diceLaunched === 4  || m.diceHand.diceLaunched === 6  || m.diceHand.diceLaunched === 8) {
					// if(m.diceHand.diceLaunched === 0)
					// 	m.playHaptic('haptic_heavyImpact', 'diceRoll');
					// else
						m.playHaptic('haptic_heavyImpact');
				}
				m.diceHand.launchNextDice();
				m.diceHand.diceLaunched++;
			}
		}
	}
	// if(m.diceStatus != 'stopped') {
	if(m.diceStatus === 'launching') {
		let movePixels = 16 * m.scaleFactor;
		//var minPixels = 0.25;
		for(let i = 0;i < m.diceHand.diceLaunched;i++) {
			let d = m.diceHand.dice[i];
			if(!d.locked){// && d.diceSprite.x && d.diceSprite.y) {
				// continue;
				let distance = getDistance(d.diceSprite.x, d.diceSprite.y, d.lastPosition.x, d.lastPosition.y);
				// let fastEnough = (Math.abs(d.diceSprite.body.velocity.x) > 2.5 && Math.abs(d.diceSprite.body.velocity.y) > 2.5);
				if(d.frameNum >= 0) {
					if(distance > movePixels) {
						d.lastPosition.x = d.diceSprite.x;
						d.lastPosition.y = d.diceSprite.y;
						if(++d.frameNum >= 9)
							d.frameNum = 0;
						// var str ='dice'+(i+1)+'_' + (d.frameNum+1);
						d.diceImage.setTexture('dice3D_sheet', (i*9)+d.frameNum);
						// console.log("X:"+d.diceSprite.x+" Y:"+d.diceSprite.y+" setting texture: "+str);
					}
				} else {
					d.diceSprite.setVelocity(0,0);
					d.diceSprite.body.angularVelocity = 0;
				}

		//            if(deltaX < minPixels && deltaY < minPixels) {
				var minVelocity = 1.5;// 4.0;
				// if(i == 0)
				// 	console.log("velocity: "+d.diceSprite.body.velocity.y);

				// var isNana = isNaN(d.diceSprite.body.velocity.x) || isNaN(d.diceSprite.body.velocity.y);
				if(Math.abs(d.diceSprite.body.velocity.x) < minVelocity && Math.abs(d.diceSprite.body.velocity.y) < minVelocity) {
					d.lastPosition.x = d.diceSprite.x;
					d.lastPosition.y = d.diceSprite.y;
					// d.diceSprite.setVelocity(0,0);
					// d.diceSprite.body.angularVelocity = 0;
					d.diceSprite.body.moves = false;
					d.diceSprite.setVelocity(0,0);
					d.diceSprite.setAngularVelocity(0);
					// d.diceSprite.body.collisionFilter.group = -1;
					// d.diceSprite.setStatic(true);
					// d.diceSprite.body.checkCollision.none = false;
					d.frameNum = -1;
					var face = d.currentFace;
					var num = ((i*6)+face);
					d.diceImage.setTexture('dice2D_sheet');
					d.diceImage.setFrame(num);

	//                d.diceSprite.setScale(0.45 * diceBigScale);

					// d.diceSprite.displayOriginX = 0;
					// d.diceSprite.displayOriginY = 0;
					// d.diceSprite.displayWidth = m.dice2DSmallScale*m.diceFullRes;
					// d.diceSprite.displayHeight = m.dice2DSmallScale*m.diceFullRes
					d.diceSprite.setScale(m.dice2DSmallScale);
					// d.diceSprite.body.setSize(m.dice2DSmallScale*m.diceActualWidth*4, m.dice2DSmallScale*m.diceActualWidth*4);
				} else {
					var collideVelocity = 10;
					// if(d.diceSprite.body.velocity.y > 0)
					if(Math.abs(d.diceSprite.body.velocity.y) < collideVelocity) {
						d.diceSprite.body.collisionFilter.group = 0;
						d.diceSprite.body.collisionFilter.mask = m.diceHand.collisionMask;
						// d.diceSprite.body.setSize(m.dice2DSmallScale*m.diceActualWidth*4, m.dice2DSmallScale*m.diceActualWidth*4);
						// d.diceSprite.displayOriginX = 0;
						// d.diceSprite.displayOriginY = 0;
						// d.diceSprite.body.checkCollision.none = false;
					}
				}
			}
		}
		if(m.diceHand.diceLaunched >= 9) {
			numDiceStopped = 0;
			for(let i=0;i < 9;i++)
				if(m.diceHand.dice[i].frameNum < 0)
					numDiceStopped++;
			if(numDiceStopped >= 9) {
				m.diceStatus = 'stopped';

				m.ui.fadeInPinkHeart();

				m.diceHand.findNearestHomePositions();
				for(let i=0;i < 9;i++) {
					let d = m.diceHand.dice[i];
					d.diceSprite.body.moves = false;
					d.diceSprite.body.collisionFilter.group = -1;
					d.diceSprite.body.collisionFilter.mask = 0;
					// d.diceSprite.setStatic(true);
					var thisTween = m.scene.tweens.add({
						targets     : [ d.diceSprite ],
						x: d.homePosition.x,
						y: d.homePosition.y,
						scaleX: m.diceBigScale,
						scaleY: m.diceBigScale,
						angle: 0,
						ease        : 'Power0',
						delay		: 0, //500,
						duration    : 420,
						repeat      : 0,
						callbackScope   : thisTween,
						completeDelay: 0,
						onComplete: function(tween, target, num){
							// console.log("onComplete tween dice "+num);
							if(num === 8) {
								m.gameState.state = "idle";
								m.diceStatus = "resolved";
								m.diceHand.resetDicePriority();

								integration.postAnalyticsEvent(`roll_complete`, `gameplay`, store.activeMatch.handNumber);

								//tutorial overlay
								if(store.tutorialMode && store.activeMatch.matchId !== 'intro'){
									m.ui.showTutorialBanner();

									if(store.activeMatch.handNumber === 1){
										if(store.activeMatch.currentHand.rollNumber === 1){
											store.tutorialState = 'waitforjacks';
											store.tutorialPreventRoll = true;
											for(var i=1;i <= 7;i++)
												m.diceHand.dice[i].darken();
											m.diceHand.dice[0].addSelectPulse();
											m.diceHand.dice[8].addSelectPulse();
											m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*m.ui.avaPanelPos, "You rolled 1 pair.\nTap the jacks to hold them.", true, 'tutorial_3');
										}
										if(store.activeMatch.currentHand.rollNumber === 2){
											store.tutorialState = 'waitforwild';
											store.tutorialPreventRoll = true;
											for(var i=2;i <= 7;i++)
												m.diceHand.dice[i].darken();
											m.diceHand.dice[1].addSelectPulse();
											m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*m.ui.avaPanelPos, "Hold your wilds!\nThey are used as the best\ndice to make your hand!", true, 'tutorial_4');
										}
									}

									if(store.activeMatch.handNumber === 2){
										if(store.activeMatch.currentHand.rollNumber === 1){
											store.tutorialState = 'waitforking';
											store.tutorialPreventRoll = true;
											for(var i=0;i <= 8;i++)
												if(i != 1 && i != 7)
													m.diceHand.dice[i].darken();
											m.diceHand.dice[1].addSelectPulse();
											m.diceHand.dice[7].addSelectPulse();
											m.ui.showSelectDiceMsg();
											m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*m.ui.avaPanelPos, "2 out of 3!\nNice Start!", true, 'tutorial_7');
											// m.diceHand.dice[1].addSelectPulse();
											// m.diceHand.dice[2].addSelectPulse();
										}
										if(store.activeMatch.currentHand.rollNumber === 2){
											store.tutorialState = 'waitforking2';
											store.tutorialPreventRoll = true;
											for(var i=0;i <= 8;i++)
												if(i != 3 && i != 2 && i != 1 && i != 7)
													m.diceHand.dice[i].darken();
											m.diceHand.dice[1].addFlair('selectedYellowDot');
											m.diceHand.dice[1].locked = true;
											m.diceHand.dice[7].addFlair('selectedYellowDot');
											m.diceHand.dice[7].locked = true;
											m.diceHand.dice[2].addSelectPulseYellowDot();
											m.diceHand.dice[3].addSelectPulseYellowDot();
											m.ui.showSelectDiceMsg();
											m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*m.ui.avaPanelPos, "Higher ranks can help\nyou win.  Select the Kings\nand deselect the 6's", true, 'tutorial_8');
										}
									}
									if(store.activeMatch.handNumber === 3) {
										if(store.activeMatch.currentHand.rollNumber === 1){
											store.tutorialState = 'waitforstraight';
											store.tutorialPreventRoll = true;
											for(var i=0;i <= 8;i++)
												if(i != 3 && i != 2 && i != 6 && i != 7 && i != 0)
													m.diceHand.dice[i].darken();
											m.diceHand.dice[2].addSelectPulse();
											m.diceHand.dice[3].addSelectPulse();
											m.diceHand.dice[7].addSelectPulse();
											m.diceHand.dice[6].addSelectPulse();
											m.diceHand.dice[0].addSelectPulse();
											m.ui.showSelectDiceMsg();
											m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*m.ui.avaPanelPos+1, m.ui.tutorialStraightText, true, 'tutorial_11');
										}
									}
								}

								// returnCup();
								if(store.tutorialMode && store.activeMatch.matchId === 'intro') {
									m.ui.showBigWinBanner();
									gameSetTimeout(m.ui.endOfShortTutorial, 1000);
									return;
								}
								// showBigWinBanner();
								if(store.activeMatch.currentHand.rollsRemaining === 0 || store.activeMatch.currentHand.best) {
									// gameSetTimeout(m.ui.showBigWinBanner, 700);
									m.ui.showBigWinBanner();
									gameSetTimeout(m.ui.showPlayHandButton, 1500-(700));
									// gameSetTimeout(returnCup, 4000);
								} else {
									// gameSetTimeout(m.cup.returnCup, 500);
									m.cup.returnCup();
								}
							}
						},
						onCompleteParams: [d.diceNum],
						onCompleteScope: thisTween,
					});
					// if(d.locked) {
					// 	var thisTween2 = m.scene.tweens.add({
					// 		targets     : [ d.highlight ],
					// 		x: d.homePosition.x,
					// 		y: d.homePosition.y,
					// 		scaleX: m.highlightScale,
					// 		scaleY: m.highlightScale,
					// 		angle: 0,
					// 		ease        : 'Power0',
					// 		delay		: 500,
					// 		duration    : 420,
					// 		repeat      : 0,
					// 		callbackScope   : thisTween,
					// 		completeDelay: 0,
					// 		onComplete: function(tween, target, num){
					// 		//console.log("onComplete tween dice "+num);
					// 		},
					// 		onCompleteParams: [d.diceNum],
					// 		onCompleteScope: thisTween2,
					// 	});
					// }
				}
			}
		}
	}
//    controls.update(delta);
}
